import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Table, TableColumn } from "../../../components/table";
import { useEffect, useState } from "react";
import { Input, InputNumber } from "antd";
import EmptyModel from "../../../components/modal/emptyModal";
import Icon from "@mdi/react";
import { mdiPlusCircle } from "@mdi/js";
import { SearchField } from "../../../components/textfield";
import NumberFormat from "react-number-format";

const UsageLog = () => {
  const [title, setTtile] = useState(
    "บันทึกการใช้ / น.ส.รังสิมา แซ่หว่าง (EK-CNT60100015)"
  );
  const [state, setState] = useState<any>({
    xdata: [],
  });
  const [isOpen, setIsOpen] = useState(false);
  const [listCourses, setListCourses] = useState<any>([]);
  const [searchSo, setSearchSo] = useState<string>("");

  const columns = [
    {
      title: "",
    },
    {
      title: "รหัส",
    },
    {
      title: "รายการ",
    },
    {
      title: "จำนวนทั้งหมด",
      align: "center",
    },
    {
      title: "จำนวนที่ใช้ครั้งนี้",
      align: "center",
    },
    {
      title: "หน่วย",
      align: "center",
    },
    {
      title: "ราคาต่อหน่วย",
      align: "center",
    },
    {
      title: "",
    },
  ];
  const data = [
    {
      code: "RA-01-082",
      list: "Aestox",
      total: "10",
      used: 3.5,
      unit: "CC",
      price_per_unit: 1500.96,
    },
    {
      code: "MA-02-033",
      list: "Juvederm Ultra Plus",
      total: "10",
      used: 2.75,
      unit: "หลอด",
      price_per_unit: 2500.86,
    },
    {
      code: "RA-01-061-02",
      list: "Aestox",
      total: "10",
      used: 1,
      unit: "CC",
      price_per_unit: 1000.0,
    },
    {
      code: "RA-01-072",
      list: "Juvederm  Volux",
      total: "10",
      used: 2,
      unit: "หลอด",
      price_per_unit: 1000.0,
    },
    {
      code: "RA-05-006",
      list: "Fractional",
      total: "100",
      used: 10,
      unit: "ช็อต",
      price_per_unit: 400.0,
    },
    {
      code: "RA-05-010",
      list: "อื่นๆ/Others",
      total: "1",
      used: 1,
      unit: "บาท",
      price_per_unit: 3000.0,
    },
  ];

  const _columns = [
    {
      title: "",
    },
    {
      title: "รหัส",
    },
    {
      title: "รายการ",
    },
    {
      title: "หน่วย",
      align: "center",
    },
    {
      title: "ราคา/หน่วย",
      align: "center",
    },
    {
      title: "เลือก",
      align: "center",
    },
  ];
  const _dataprocedure = [
    {
      _id: 1,
      code: "ATFS0802",
      list: "Laser Face",
      unit: "กล่อง",
      unitprice: 100.0,
    },
    {
      _id: 2,
      code: "AFS0803",
      list: "Laser Body",
      unit: "กล่อง",
      unitprice: 100.59,
    },
    {
      _id: 4,
      code: "AFS0804",
      list: "Laser leg",
      unit: "กล่อง",
      unitprice: 100.59,
    },
    {
      _id: 5,
      code: "AFS0805",
      list: "Laser Face2",
      unit: "กล่อง",
      unitprice: 100.59,
    },
    {
      _id: 6,
      code: "AFS0806",
      list: "Laser body2",
      unit: "กล่อง",
      unitprice: 100.59,
    },
    {
      _id: 7,
      code: "AFS0807",
      list: "Laser body2",
      unit: "กล่อง",
      unitprice: 100.59,
    },
  ];

  const onUsedChange = (value: any, index: number) => {
    const data = state.xdata;

    data[index].used = (Math.round(value * 100) / 100).toFixed(2);

    setState({ ...state, data });
  };

  const getApi = async () => {
    // get api
    const usedCourses = data;
    setState({ ...state, xdata: usedCourses });

    setListCourses(_dataprocedure);
  };

  function onClose() {
    setIsOpen(false);
  }

  function onHandledata(data: any) {
    console.log("data", data);
    const xdata = state.xdata;
    xdata.push(data);

    setState({ ...state, xdata });

    // setDataChooses(data);
    //const data = state.data
  }

  useEffect(() => {
    getApi();
  }, []);

  useEffect(() => {
    // console.log("state =>", state);
  }, [state]);

  return (
    <div>
      <HeaderBar btnBack={true} title={title}>
        <MainButton
          title="เพิ่มรายการ"
          onClick={() => {
            setIsOpen(true);
          }}
        />
      </HeaderBar>
      <div style={{ margin: "20px 80px" }}>
        <EmptyModel show={isOpen} onClose={onClose} width="80%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>เลือกรายการ</h4>
            <div className="row justify-center  mt-20">
              <SearchField
                placeholder=""
                color="#FFFFFF"
                value={searchSo}
                onChange={(e) => {
                  setSearchSo(e.target.value);
                }}
              />
            </div>
            <div className="row justify-start mt-20">
              <div className="ex3">
                <Table header={_columns}>
                  {listCourses.map((item: any, index: number) => {
                    const index2 = state.xdata.findIndex(
                      (m: any) => m.code === item.code
                    );
                    //console.log("index", index2);
                    return (
                      <tr
                        key={index}
                        // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                        style={{ cursor: "pointer", border: "0px" }}
                      >
                        <TableColumn width="3%" align="center">
                          {index + 1}
                        </TableColumn>
                        <TableColumn width="10%">{item.code}</TableColumn>
                        <TableColumn width="40%">{item.orderlist}</TableColumn>
                        <TableColumn width="10%" align="center">
                          {item.unit}
                        </TableColumn>
                        <TableColumn width="10%" align="center">
                          {item.unitprice}
                        </TableColumn>
                        <TableColumn width="5%" align="center">
                          {index2 !== -1 ? (
                            <Icon
                              path={mdiPlusCircle}
                              size="30"
                              color="#D3D8DD"
                            />
                          ) : (
                            <div
                              onClick={(e: any) => {
                                setIsOpen(false);
                                return onHandledata(item);
                              }}
                            >
                              <Icon
                                path={mdiPlusCircle}
                                size="30"
                                color="#4D7E7F"
                              />
                            </div>
                          )}
                        </TableColumn>
                      </tr>
                    );
                  })}
                </Table>
              </div>
            </div>
          </div>
        </EmptyModel>
        <h5>รายการที่ใช้ในคอร์ส ครั้งที่ 9</h5>
        <Table header={columns}>
          {state.xdata.map((item: any, index: number) => (
            <tr
              key={index}
              // onClick={() => history.push(`/usedcourse/${item.SO}`)}
              style={{ cursor: "pointer" }}
            >
              <TableColumn width="3%" align="center">
                {index + 1}
              </TableColumn>
              <TableColumn width="10%">{item.code}</TableColumn>
              <TableColumn width="25%">{item.list}</TableColumn>
              <TableColumn width="10%" align="center">
                {item.total}
              </TableColumn>
              <TableColumn width="10%" align="center">
                <InputNumber
                  value={item.used}
                  min="0"
                  step="0.05"
                  onChange={(e: any) => {
                    onUsedChange(e, index);
                  }}
                  stringMode
                  style={{
                    boxShadow: "initial",
                    borderColor: "#ced4da",
                  }}
                  type="number"
                />
              </TableColumn>
              <TableColumn width="10%" align="center">
                {item.unit}
              </TableColumn>
              <TableColumn width="10%" align="right">
                {
                  <NumberFormat
                    value={(
                      Math.round(item.price_per_unit * 100) / 100
                    ).toFixed(2)}
                    displayType="text"
                    thousandSeparator={true}
                  />
                }
              </TableColumn>
              <TableColumn width="5%" align="center">
                {""}
              </TableColumn>
            </tr>
          ))}
          <tr>
            <TableColumn align="center" colspan={6}>
              <b>รวม</b>
            </TableColumn>
            <TableColumn align="center" colspan={2}>
              <b>
                {
                  <NumberFormat
                    value={(Math.round(18500.5 * 100) / 100).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                }
              </b>
            </TableColumn>
          </tr>
        </Table>
        <div className="justify-center mt-20">
          <MainButton title="ย้อนกลับ" className="mg-10" background="#E76464" />
          <MainButton title="บันทึก" className="mg-10" />
        </div>
      </div>
    </div>
  );
};
export default UsageLog;
